import { render, staticRenderFns } from "./vehicleManagement.vue?vue&type=template&id=c70a1336&scoped=true&"
import script from "./vehicleManagement.vue?vue&type=script&lang=js&"
export * from "./vehicleManagement.vue?vue&type=script&lang=js&"
import style0 from "./vehicleManagement.vue?vue&type=style&index=0&id=c70a1336&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70a1336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c70a1336')) {
      api.createRecord('c70a1336', component.options)
    } else {
      api.reload('c70a1336', component.options)
    }
    module.hot.accept("./vehicleManagement.vue?vue&type=template&id=c70a1336&scoped=true&", function () {
      api.rerender('c70a1336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vehicleManagement.vue"
export default component.exports